const { PUBLIC_URL = '' } = process.env
export const COMPLIANTS_ESCALATION_DATA = {
  blocks: [
    {
      key: '6efkk',
      text: 'Level 1: Customers can lodge their queries, requests, complaints and feedback at care@jiopay.in. All queries, requests, complaints and feedback received from the customers will be attended promptly and in any case within 10 working days from the date of receipt.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [
        { offset: 0, length: 9, style: 'BOLD' },
        { offset: 0, length: 80, style: '#757575' },
        { offset: 97, length: 165, style: '#757575' },
      ],
      entityRanges: [{ offset: 81, length: 14, key: 0 }],
      data: {},
    },
    { key: '52apl', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '86qrd',
      text: 'Level 2: In case of non-redressal of complaint within the specified time period or unsatisfactory resolution at Level 1, customers can escalate the matter to Ms. Kausar Hasan (Nodal Officer) by sending an email at nodal.officer@jiopay.in. Nodal Officer will get back to the customer within 10 working days from the date of escalation.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [
        { offset: 0, length: 9, style: 'BOLD' },
        { offset: 0, length: 214, style: '#757575' },
        { offset: 237, length: 98, style: '#757575' },
      ],
      entityRanges: [{ offset: 214, length: 23, key: 1 }],
      data: {},
    },
    { key: '8bdr0', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'ds7t5',
      text: 'Level 3: If the customer is not satisfied with the resolution provided or the customer does not receive any resolution within one month from the date of complaint, customer can approach the ‘Ombudsman for Digital Transactions’ for an independent review. The details of and the procedure for filing complaint with the ‘Ombudsman for Digital Transactions’ are available at https://rbidocs.rbi.org.in/rdocs/Content/PDFs/OSDT31012019.pdf',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [
        { offset: 0, length: 9, style: 'BOLD' },
        { offset: 0, length: 371, style: '#757575' },
      ],
      entityRanges: [{ offset: 371, length: 62, key: 2 }],
      data: {},
    },
    { key: '9s4ok', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '6a661',
      text: 'For more details on Complaint Resolution and Escalation Matrix, kindly refer to our Grievance Redressal Policy at https://jiopay.in/docs/Grievance/Grievance-Redressal-Policy.pdf',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 114, style: '#757575' }],
      entityRanges: [{ offset: 114, length: 64, key: 3 }],
      data: {},
    },
  ],
  entityMap: {
    '0': { type: 'LINK', mutability: 'MUTABLE', data: { url: 'mailto:care@jiopay.in' } },
    '1': { type: 'LINK', mutability: 'MUTABLE', data: { url: 'mailto:nodal.officer@jiopay.in' } },
    '2': {
      type: 'LINK',
      mutability: 'MUTABLE',
      data: { url: 'https://rbidocs.rbi.org.in/rdocs/Content/PDFs/OSDT31012019.pdf#page=1' },
    },
    '3': {
      type: 'LINK',
      mutability: 'MUTABLE',
      data: { url: `${PUBLIC_URL}/docs/Grievance/Grievance-Redressal-Policy.pdf#page=1` },
    },
  },
}
